import { render } from "./SplitByIdModal.vue?vue&type=template&id=460d1b78&scoped=true&lang=pug"
import script from "./SplitByIdModal.vue?vue&type=script&lang=js"
export * from "./SplitByIdModal.vue?vue&type=script&lang=js"

import "./SplitByIdModal.vue?vue&type=style&index=0&id=460d1b78&lang=scss&scoped=true"
import "./SplitByIdModal.vue?vue&type=style&index=1&id=460d1b78&lang=css"
const cssModules = {}
import style2 from "./SplitByIdModal.vue?vue&type=style&index=2&id=460d1b78&lang=scss&module=true"
cssModules["$style"] = style2

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-460d1b78"]])

export default __exports__